import { useRequest } from "~/v2/api/hooks";
import { queryKeys } from "~/v2/api/queryKeys";
import type { Order } from "~/v2/api/rest/account";
import { getAtdOrder } from "./api";

export interface UseAtdOrderDetailParams {
  accountID?: string;
  product?: "live" | "paper";
  orderID?: string;
  enabled: boolean;
  requireFresh?: boolean;
}

export const useAtdOrderDetail = ({
  accountID,
  product,
  orderID,
  enabled,
  requireFresh = false,
}: UseAtdOrderDetailParams) =>
  useRequest<Order | null>(
    queryKeys.orders.detail(accountID ?? "", orderID ?? "", product),
    () => {
      if (!accountID || !product || !orderID) {
        return Promise.resolve(null);
      }
      return getAtdOrder({ accountID, product, orderID });
    },
    {
      enabled: enabled && Boolean(accountID && product && orderID),
      meta: { showErrorToast: false },
      retry: false,
      refetchOnMount: requireFresh ? "always" : undefined,
    },
  );
